import React from 'react';

function Lamp(props){
  return (
    <svg id="overlay" />
  )
}

export default Lamp;


// WEBPACK FOOTER //
// ./src/components/Lamp.js